/* letsfeed.io — logo şeridi (marquee)

   Kaynak site şeridi Web Animations API ile sürüyordu. Port'ta akışın
   kendisi CSS animasyonu (bkz. letsfeed-base.css "Logo şeridi" bloğu);
   bu betik yalnızca iki şey yapıyor:

     1) Süreyi izin GERÇEK genişliğinden yeniden hesaplıyor, böylece hız
        içerik ya da yazı tipi değişse de canlıdaki 27.85 px/sn'de kalıyor.
     2) "Durdur" düğmesini bağlıyor.

   Betik hiç yüklenmezse şerit CSS'teki varsayılan süreyle akmaya devam
   eder ve düğme yalnızca işlevsiz kalır — içerik kaybolmaz. */
(function () {
  var HIZ = 27.85; /* px/sn — canlı letsfeed.io'dan ölçüldü */

  function kur(kok) {
    /* 1) süre = bir kopyanın genişliği / hız.
       İz iki özdeş kopya taşıdığı için scrollWidth'in yarısı bir kopyadır. */
    var izler = kok.querySelectorAll('.lf-marquee');
    for (var i = 0; i < izler.length; i++) {
      var bir = izler[i].scrollWidth / 2;
      /* Yazı tipleri yüklenmeden ölçülürse genişlik küçük çıkar; absürt
         kısa süre yazmamak için alt sınır koyuyoruz. */
      if (bir > 200) {
        izler[i].style.setProperty('--lf-marquee-sure', (bir / HIZ).toFixed(1) + 's');
      }
    }

    /* 2) Durdur / Sürdür */
    var dugme = kok.querySelector('[data-lf-marquee-dugme]');
    if (!dugme || dugme.dataset.lfBagli) return;
    dugme.dataset.lfBagli = '1';
    var etiket = dugme.querySelector('[data-lf-marquee-etiket]');

    dugme.addEventListener('click', function () {
      var durdu = kok.getAttribute('data-lf-marquee') === 'durdu';
      kok.setAttribute('data-lf-marquee', durdu ? 'akiyor' : 'durdu');
      dugme.setAttribute('aria-pressed', durdu ? 'false' : 'true');
      dugme.setAttribute('aria-label',
        durdu ? 'Logo akışını durdur' : 'Logo akışını sürdür');
      if (etiket) etiket.textContent = durdu ? 'Durdur' : 'Sürdür';
    });
    dugme.setAttribute('aria-pressed', 'false');
  }

  function hepsi() {
    var kokler = document.querySelectorAll('.lf');
    for (var i = 0; i < kokler.length; i++) kur(kokler[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsi);
  } else {
    hepsi();
  }
  /* Yazı tipi geç yüklenirse genişlik değişir; süreyi tazele. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(hepsi);
  /* Tema düzenleyicisinde bölüm yeniden basıldığında. */
  document.addEventListener('shopify:section:load', hepsi);
})();
